import React, { Component } from "react";
import Keycloak from 'keycloak-js';
import { Link } from "react-router-dom";
import { Button, Card, Col, Container, Image, Row } from "react-bootstrap";

import AuthenticationModal from "./MaenadaAuthenticationModal";

export type PotentialLandingVerifierState = {
  showAuthenticationModal?: boolean;
  mandatoryOnly?: boolean;
  payload?: any;
  authenticated?: boolean;
  token?: string;
};

export type PotentialLandingVerifierProps = {

};

export default class PotentialLandingVerifier extends Component<PotentialLandingVerifierProps, PotentialLandingVerifierState> {
  state: PotentialLandingVerifierState = {};


  render() {
    if (!this.state.authenticated) return null;
    return (
      <div
        style={{
          width: "100%",
          // backgroundImage: "url('https://st.depositphotos.com/13400724/54064/v/450/depositphotos_540644508-stock-illustration-monochrome-simple-geometric-effect-background.jpg')", // TODO: Change background image if needed
          // backgroundRepeat: "no-repeat",
          backgroundSize: "100%",
        }}
      >
        <Container style={{ height: "80vh" }}>
          <Container className="mt-5">
            <h1 style={{ textShadow: "1px 1px 2px white" }}>
              Simple Verifier UI
            </h1>
            {/*TODO: Change title*/}
            <h3 className="pt-4" style={{ textShadow: "1px 1px 2px white" }}>
              
            </h3>
          </Container>
          <Row style={{ marginTop: "150px" }}>
            <Col>
              <Card style={{ backgroundColor: "black" }}>
                <Card.Body style={{ color: "white", textAlign: "center" }}>
                  <Image
                    src="https://cdn-icons-png.flaticon.com/512/80/80118.png"
                    height="80"
                    width="100"
                    style={{
                      filter:
                        "invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)",
                    }}
                  />
                  {/*TODO: Change title and text for the card*/}
                  <Card.Title>Mandatory Attributes</Card.Title>
                  <Card.Text>
                    PID - Present Mandatory Attributes Only
                  </Card.Text>
                  {/*TODO: Change link to page*/}
                    <Button onClick={this.showLoginDialogMandatory} variant="primary">Mandatory Attributes</Button>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card style={{ backgroundColor: "#1f698d" }}>
                <Card.Body style={{ color: "white", textAlign: "center" }}>
                  <Image
                    src="https://cdn-icons-png.flaticon.com/512/80/80118.png"
                    height="80"
                    width="100"
                    itemProp="thumbnailUrl"
                    style={{
                      filter:
                        "invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)",
                    }}
                  ></Image>
                  {/*TODO: Change title and text for the card*/}
                  <Card.Title>Mandatory and Optional Attributes</Card.Title>
                  <Card.Text>
                    PID - Present Mandatory and Optional Attributes
                  </Card.Text>
                  {/*TODO: Change link to page*/}
                    <Button onClick={this.showLoginDialogAll} variant="primary">Mandatory and Optional Attributes</Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
        <AuthenticationModal
              show={this.state.showAuthenticationModal as boolean}
              onCloseClicked={this.hideLoginDialog}
              mandatoryOnly={this.state.mandatoryOnly}
              token={this.state.token}
              onSignInComplete={this.completeSignIn} />
      </div>
    );
  }

  private showLoginDialogMandatory = () => {
    this.setState({ showAuthenticationModal: true, mandatoryOnly: true });
  };
  private showLoginDialogAll = () => {
    this.setState({ showAuthenticationModal: true, mandatoryOnly: false });
  };

  private hideLoginDialog = () => {
    this.setState({ showAuthenticationModal: false });
  };

  private completeSignIn = (payload: any) => {
    this.setState({ showAuthenticationModal: false, payload });
  };
}
